/* src/app/components/payroll/invoices/provider/provider-invoice/add-invoice/add-invoice.component.css */
.custom-width {
  max-width: 160px;
  min-width: 50px;
  display: inline-block;
  margin: 0 6px;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0 !important;
}
.control-height {
  height: 30px;
}
.custom-btn-row {
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-border {
  border: 1px solid red !important;
}
ppl-date-picker.error-border {
  border: none !important;
}
::ng-deep ppl-date-picker.error-border .datepicker-wrapper {
  border: 1px solid red !important;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.ant-checkbox-wrapper.error-class {
  border: 1px solid red !important;
}
.ppl-form-label {
  margin-bottom: 5px !important;
}
.custom-checkbox {
  width: 16px;
  height: 16px;
  text-align: center;
  padding-top: 14px;
}
.attestation-row {
  width: 100%;
  margin: 8px 0 12px;
}
.attestation-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.929rem;
  font-weight: 600;
  margin-bottom: 0;
}
.attestation-label .custom-checkbox {
  padding-top: 0;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
}
.attestation-label .required-mark {
  color: red;
}
.success-status {
  color: blue;
  font-weight: bold;
}
.ppl-form-label {
  font-weight: 600;
}
table {
  font-size: 13px !important;
}
.table-wrapper {
  width: 100%;
  position: relative;
  overflow-y: visible;
  overflow-x: auto;
}
th {
  background-color: #a8e4e14d;
}
.table-fixed {
  table-layout: fixed;
}
tr {
  vertical-align: top;
}
.table-view {
  min-width: 100%;
  border-collapse: collapse;
  width: max-content;
  table-layout: auto;
}
td nz-select,
td .ant-select {
  width: 100% !important;
}
.ant-select-selector {
  width: 100% !important;
  min-width: 100% !important;
  display: flex !important;
  align-items: center;
}
.ant-select-selection-search-input {
  width: 100% !important;
  min-width: 100% !important;
}
.action-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
  box-sizing: border-box;
}
.act-btn-margin {
  margin-right: 8px;
}
:host ::ng-deep ppl-upload .list-container {
  width: 100%;
  margin: 0;
  padding-left: 0;
  list-style: none;
  box-sizing: border-box;
}
:host ::ng-deep ppl-upload .file-details {
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
  row-gap: 4px;
}
:host ::ng-deep ppl-upload .file-details > span.text-hidden {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep ppl-upload .file-details > span.text-hidden:nth-of-type(2) {
  flex: 1 1 140px;
}
:host ::ng-deep ppl-upload .file-details > .file-actions {
  flex-shrink: 0;
  margin-left: auto;
}
/*# sourceMappingURL=add-invoice.component-TMRZKQ47.css.map */
